<template>
    <v-tabs class="tab-bar-fixed" fixed-tabs background-color="#FCE9C5">
        <v-tab to="/">
            Home
        </v-tab>
        <v-tab to="/my-stats">
            My Stats
        </v-tab>
        <v-tab to="/weekly-scores">
            Weekly Scores
        </v-tab>
        <v-tab to="/league">
            League Table
        </v-tab>
        <v-tab to="/sudden-death" v-if="settings_sd_switch">
            Sudden Death
        </v-tab>
        <v-tab to="/chat">
            Chat
        </v-tab>
    </v-tabs>
</template>

<script>
  import { helpers } from "../store/helpers";

  export default {
    name: "Tabs",
    data () {
      return {
        //
      }
    },
    computed: {
      ...helpers,
    },
    created() {

    }
  }
</script>

<style scoped>

    .tab-bar-fixed {
        font-family: "Barlow-SemiBold";
        position: -webkit-sticky;
        position: sticky;
        top: 3.5rem;
        z-index: 2;
    }

</style>
